import * as React from 'react';

function SvgMakePayment(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h24v24H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.982 6H5v15.5h14v-3.875h-2v-1.041a5.001 5.001 0 00.282-9.034h1.7V6z"
        fill="#FCCE01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.15 3A1.85 1.85 0 012 1.15h16A1.85 1.85 0 0119.85 3v3.29a6.003 6.003 0 010 11.42v4.352c0 .9-1.058 1.383-1.738.793l-1.362-1.182-1.562 1.355a1.05 1.05 0 01-1.376 0l-1.562-1.355-1.562 1.355a1.05 1.05 0 01-1.376 0L7.75 21.673l-1.562 1.355a1.05 1.05 0 01-1.376 0L3.25 21.673l-1.362 1.182c-.68.59-1.738.107-1.738-.793v-3.71a.85.85 0 111.7 0v2.285l.712-.618a1.05 1.05 0 011.376 0L5.5 21.375l1.562-1.356a1.05 1.05 0 011.376 0L10 21.375l1.562-1.356a1.05 1.05 0 011.376 0l1.562 1.356 1.562-1.356a1.05 1.05 0 011.376 0l.712.618v-2.639L18 18a6 6 0 11.15-11.998V3a.15.15 0 00-.15-.15H2a.15.15 0 00-.15.15v11.5a.85.85 0 01-1.7 0V3zM4 6a1 1 0 011-1h6a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h4a1 1 0 010 2H5a1 1 0 01-1-1zm1 3a1 1 0 100 2h2a1 1 0 100-2H5zm13 3.3a4.3 4.3 0 100-8.6 4.3 4.3 0 000 8.6zm2.207-2.829a.85.85 0 01-1.178.236l-1.5-1A.85.85 0 0117.15 12V9.5a.85.85 0 011.7 0v2.045l1.121.748a.85.85 0 01.236 1.179z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgMakePayment;
